export const isMp4 = url => {
  if (!url) return false;
  const fileExtension = url.split(".").pop();
  if (fileExtension && fileExtension.toLowerCase() === "mp4") {
    return true;
  }
  return false;
};
